/* eslint-disable camelcase */
export default {
  metrics: "Metrics",
};
